// extracted by mini-css-extract-plugin
export default {"container":"DigitalCrown_container__N-qvA","image":"DigitalCrown_image__TzQBd","text":"DigitalCrown_text__4Ivl-"};